import { Box, Grid, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimelineIcon from '@mui/icons-material/Timeline';
import { Stat, SubLine } from '../../../../helperComponents/showPrimitives';
import { StatusChip } from '../../ads_ingest_runs/components/StatusChip';
import { formatDuration } from '../../../../../helpers/adsIngestRunsHelpers';
import {
  formatSchedule,
  formatDateTime
} from '../../../../../helpers/adsJobsHelpers';

export const JobShowStats = ({ record }) => {
  const lastRun = Array.isArray(record.runs) && record.runs.length ? record.runs[0] : null;
  const hasWindow = record.snapshot || (record.window_days !== null && record.window_days !== undefined);
  const windowText = record.snapshot ? 'snapshot' : `window ${record.window_days} days`;

  return (
    <Grid container spacing={2} sx={{ mb: 2, px: 1 }}>
      <Stat icon={<AccessTimeIcon fontSize="small" />} caption="Schedule">
        <Typography variant="h6" fontWeight={600}>{formatSchedule(record)}</Typography>
        <SubLine>{hasWindow ? `${windowText} · ` : ''}priority {record.priority}</SubLine>
        <SubLine>expires: {record.expires_at ? formatDateTime(record.expires_at) : 'never'}</SubLine>
      </Stat>
      <Stat icon={<TimelineIcon fontSize="small" />} caption="Last delivery">
        {lastRun ? (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <StatusChip status={lastRun.display_status} />
              <Typography variant="h6" fontWeight={600}>{formatDateTime(lastRun.received_at)}</Typography>
            </Box>
            <SubLine>
              {lastRun.rows_received ?? '–'} / {lastRun.rows_written ?? '–'} rows · {formatDuration(lastRun.duration_ms)}
            </SubLine>
          </>
        ) : (
          <Typography variant="h6" fontWeight={600}>never</Typography>
        )}
      </Stat>
    </Grid>
  );
};
